import { render, staticRenderFns } from "./EstablishmentRoleTable.vue?vue&type=template&id=32e38406&"
import script from "./EstablishmentRoleTable.vue?vue&type=script&lang=js&"
export * from "./EstablishmentRoleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports